const socialIconsData = [
  {
    url: "https://api.whatsapp.com/send/?phone=918308010405&text&type=phone_number&app_absent=0",
    network: "whatsapp",
    bgColor: "#25D366",
  },
  {
    url: "https://www.facebook.com/mitadtmanet",
    network: "facebook",
    bgColor: "#1877F2",
  },
  {
    url: "https://www.youtube.com/channel/UCmQiQ_blLqj8TqpazHXm1ow/videos?view_as=subscriber",
    network: "youtube",
    bgColor: "#FF0000",
  },
  // {
  //   url: "https://twitter.com",
  //   network: "twitter",
  //   bgColor: "#1DA1F2",
  // },
  {
    url: "https://www.instagram.com/manetpune_official?igsh=MTJhdjV0ejZlamwwbg%3D%3D&utm_source=qr",
    network: "instagram",
    bgColor: "#E1306C",
  },
  {
    url: "https://www.linkedin.com/in/maharashtra-academy-of-naval-education-training-manet-a58351228",
    network: "linkedin",
    bgColor: "#0077B5",
  },
];

export default socialIconsData;
